import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "@material-ui/core/styles";
import Session from "react-session-api";
import LoginGlass from "./components/LoginGlass";
import NavBar from "./components/biztran_controls/NavBar";

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#857676",
//       dark: "#202d73",
//       text: "#ffffff",
//       icons: "#857676",
//       gradient: "linear-gradient(90deg,  #E51C24,#E51C24)",
//       IwColor:"#1E90FF",
//       ImColor:"#FF6347",
//       PSTColor:"#4682B4",
//     },
//     secondary: {
//       main: "#88E51C",
//       //main: "#00239CFF",
//       dark: "#b51009",
//       text: "#000000",
//       icons: "#E51C24",
//       gradient: "linear-gradient(90deg, #E51C24, #E51C24)",
//     },
//     tertiary: {
//       main: "#909090",
//       gradient: "linear-gradient(90deg, #909090, #909090)",
//     },
//   },
// });

const theme = createTheme({
  palette: {
    primary: {
      main: "#980a0a",
      dark: "#202d73",
      text: "white",
      //text: "black",
      icons: "black",
      gradient: "linear-gradient(90deg,  #E51C24,#E51C24)",
      IwColor: "#fafafa",
      ImColor: "#fafafa",
      PSTColor: "#fafafa",
    },
    secondary: {
      //main: "#566B73",
      //main: "#CECECE",
      main: "#7f2153",
      grid: "#7f2153",
      // grid: "#980a0a",
      // hover: '#4bc0fa',
      hover: '#9575DE',
      dark: "#b51009",
      text: "#000000",
      //text: "white",
      icons: "black",//"#E51C24",
      gradient: "linear-gradient(90deg, #E51C24, #E51C24)",
    },
    tertiary: {
      main: "#909090",
      background: "black",
      gradient: "linear-gradient(90deg, #909090, #909090)",
    },
  },
});


// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#C8102E",
//       dark: "#202d73",
//       text: "#ffffff",
//       icons: "#857676",
//       gradient: "linear-gradient(90deg,  #E51C24,#E51C24)",
//     },
//     secondary: {
//       main: "#88E51C",
//       //main: "#00239CFF",
//       dark: "#b51009",
//       text: "#000000",
//       icons: "#E51C24",
//       gradient: "linear-gradient(90deg, #E51C24, #E51C24)",
//     },
//     third: {
//       main: "FFFF00",
//       //main: "#00239CFF",
//       dark: "#b51009",
//       text: "#000000",
//       icons: "FFFF00",
//       gradient: "linear-gradient(90deg, #E51C24, #E51C24)",
//     },
//     tertiary: {
//       main: "#909090",
//       gradient: "linear-gradient(90deg, #909090, #909090)",
//     },
//   },
// });

const App = () => {
  const [IsLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    Session.onSet(setLoginStatus);
    Session.config(true, 30);
    if (
      Session.get("UID") !== undefined &&
      Session.get("UID") !== "" &&
      Session.get("UID") !== null
    ) {
      //console.log(Session.get("UID"));
      setIsLoggedIn(true);
    }
    //console.log(Session.get("UID"));
  }, []);

  const setLoginStatus = (data) => {
    if (
      data["UID"] === undefined ||
      data["UID"] === "" ||
      data["UID"] === null
    ) {
      setIsLoggedIn(false);
    } else {
      setIsLoggedIn(true);
    }
  };

  if (IsLoggedIn === false) {
    return (
      <ThemeProvider theme={theme}>
        <LoginGlass setIsLoggedIn={setIsLoggedIn} />
      </ThemeProvider>
    );
  } else {
    return (
      <ThemeProvider theme={theme}>
        <NavBar setIsLoggedIn={setIsLoggedIn} />
      </ThemeProvider>
    );
  }
};

export default App;
